import { createCrudService } from './createCrudService';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { MOCK_NEWSPAPERS } from 'mock/newspaperMaster.mock';

export const toNewspaper = (raw) =>
  raw && {
    id: raw.id,
    newspaper_name: raw.newspaper_name ?? '',
    editions: raw.editions ?? [],
    action: raw.action,
    keywords: raw.keywords ?? [],
    enable_keyword_search: raw.enable_keyword_search ?? true,
    source: raw.source ?? 'epaper_pdf',
    source_url: raw.source_url ?? '',
    source_telegram_channel: raw.source_telegram_channel ?? '',
    whatsapp_phone_numbers: raw.whatsapp_phone_numbers ?? [],
    status: raw.status,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
  };

const toPayload = (model) => ({
  type: 'newspaper',
  newspaper_name: model.newspaper_name,
  editions: model.editions ?? [],
  action: model.action,
  keywords: model.keywords ?? [],
  enable_keyword_search: model.enable_keyword_search,
  source: model.source,
  source_url: model.source_url,
  source_telegram_channel: model.source_telegram_channel,
  whatsapp_phone_numbers: model.whatsapp_phone_numbers ?? [],
  status: model.status,
});

export const newspaperService = createCrudService({
  endpoints: API_ENDPOINTS.NEWSPAPERS,
  toModel: toNewspaper,
  toPayload,
  mockSeed: MOCK_NEWSPAPERS,
  idPrefix: 'np',
});

newspaperService.getDailySummary = async () => {
  const { httpClient } = await import('./api/httpClient');
  const { isMockEnabled, mockResponse } = await import('./api/mockAdapter');
  if (isMockEnabled()) {
    // Return a mock summary
    return mockResponse({
      total_configured: MOCK_NEWSPAPERS.length,
      date: new Date().toISOString().split('T')[0],
      summary_time_config: '12:00',
      successful: [],
      failed: [
        { id: '1', newspaper_name: 'Mock Failed 1', edition: 'Ed 1', source: 'Telegram', status: 'Failed' },
        { id: '2', newspaper_name: 'Mock Failed 2', edition: 'Ed 2', source: 'WhatsApp', status: 'Failed' },
        { id: '3', newspaper_name: 'Mock Failed 3', edition: 'Ed 3', source: 'Telegram', status: 'Failed' }
      ],
      missed: [
        { id: '4', newspaper_name: 'Mock Missed 1', edition: 'Ed 1', source: 'Manual', status: 'Missed' }
      ]
    });
  }
  return httpClient.get(API_ENDPOINTS.NEWSPAPERS.DAILY_SUMMARY);
};

newspaperService.dismissNotification = async (id) => {
  const { httpClient } = await import('./api/httpClient');
  return httpClient.post(API_ENDPOINTS.NEWSPAPERS.DISMISS(id));
};

export default newspaperService;
